module.exports = __webpack_public_path__ + "img/wxt1.69834899.jpg";